import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { isNil } from 'ngx-cookie';
import { Email } from '../models/email.model';
import { EventUser } from '../models/eventUser.model';
import { SMS } from '../models/sms.model';
import { MessageTemplate } from '../models/template.model';
import { ContactService } from '../services/contact.service';
import 'bootstrap/dist/js/bootstrap.bundle';
import { Contact } from '../models/contact.model';
import { environment } from './../../../environments/environment';
import { TenantService } from 'src/app/tenant/tenant.service';
import { GlobalService } from '../services/global.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import FroalaEditor from 'froala-editor';
import { IdentityService } from '../services/identity.service';
import { BatchEmail, DirectBatchEmail } from '../models/batch-email.model';
import { BatchText, DirectBatchText } from '../models/batch-text.model';
import { Direct } from 'protractor/built/driverProviders';
import { AttachmentComponent } from '../attachment/attachment.component';
import { attachment } from '../attachment/attachment.model';
import { Router } from '@angular/router';
import { AppService } from '../services/app.service';
import { AuthService } from 'src/app/core/account/auth.service';
import { formatDate } from '@angular/common';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { BatchNotification, DirectBatchNotification } from '../models/batch-notification.model';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
  standalone: false
})
export class ContactComponent implements OnInit {
  @ViewChild('myMessage') MessageElement: ElementRef;
  @ViewChild('attachmentComponent', { static: false })
  attachmentComponent: AttachmentComponent;
  @Input() EventId: number;
  @Input() ContactsList: number[] = null;
  @Input() FullContactsList: Contact[];
  @Input() Transmission: string;
  @Input() SenderEmail: string;
  @Input() SenderName: string;
  @Input() Global: boolean;

  loadEditor = false;
  isLoading: boolean = true;
  safeMessage: SafeHtml;
  EmailTemplate: string = '';
  TextTemplate: string = '';
  Subject: string = '';
  Subtitle: string = '';
  Message: string = '';
  InsertName: string = '';
  Acknowledge: string = '';
  Sent: boolean = false;
  PreviewMode: boolean = false;
  NewTemplate: boolean = false;
  PreviewBody: string = '';
  ConfirmSend: boolean = false;
  IsUnicode: boolean = false;
  caretPos: number;
  caretEndPos: number;
  RecepientsCount: number;
  filteredUsers: EventUser[] = null;
  newTemplateName: string = '';
  recipientMessage: string = '';
  sent: boolean = false;
  templateArr: MessageTemplate[] = [];
  curTemplate: MessageTemplate = null;
  TemplateSaved: boolean = false;
  SavingTemplate: boolean = false;
  selectedTemplateIndex: number = null;
  church: string = '';
  isSending: boolean = false;
  GroupSender: string = null;
  attachments: attachment[];
  subscriptionError: boolean = false;
  TemplateDelete: boolean = false;
  currentDate: string = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  startTime: string = formatDate(new Date(), 'HH:mm:ss', 'en');
  scheduleSend: boolean = false;
  sanitizedContent: SafeHtml;

  constructor(
    public contactService: ContactService,
    private tenantService: TenantService,
    public globalService: GlobalService,
    private sanitizer: DomSanitizer,
    private identityService: IdentityService,
    private _router: Router,
    private appService: AppService,
    private authService: AuthService,
  ) { }

  async ngOnInit() {
    await this.authService.autoLogin(1);
    var tenantData = await this.tenantService.getTenantData();
    if (tenantData.deleted == true) {
      this._router.navigate(['/service-notfound']);
      return;
    }
    this.church = tenantData.name;
    var changeDirection = function (dir, align) {
      // Wrap block tags.
      this.selection.save();
      this.html.wrap(true, true, true, true);
      this.selection.restore();

      // Get blocks.
      var elements = this.selection.blocks();

      // Save selection to restore it later.
      this.selection.save();

      for (var i = 0; i < elements.length; i++) {
        var element = elements[i];
        if (element != this.el) {
          this.$(element)
            .css('direction', dir)
            .css('text-align', align)
            .removeClass('fr-temp-div');
        }
      }

      // Unwrap temp divs.
      this.html.unwrap();

      // Restore selection.
      this.selection.restore();
    };

    FroalaEditor.DefineIcon('rightToLeft', {
      NAME: 'long-arrow-alt-right',
      template: 'font_awesome_5',
    });
    FroalaEditor.RegisterCommand('rightToLeft', {
      title: 'RTL',
      focus: true,
      undo: true,
      showOnMobile: true,
      refreshAfterCallback: true,
      callback: function () {
        changeDirection.apply(this, ['rtl', 'right']);
      },
    });

    FroalaEditor.DefineIcon('leftToRight', {
      NAME: 'long-arrow-alt-left',
      template: 'font_awesome_5',
    });
    FroalaEditor.RegisterCommand('leftToRight', {
      title: 'LTR',
      focus: true,
      undo: true,
      showOnMobile: true,
      refreshAfterCallback: true,
      callback: function () {
        changeDirection.apply(this, ['ltr', 'left']);
      },
    });

    this.Message = '';
    switch (this.Transmission) {
      case 'EMAIL':
        await this.getTemlates(0);
        break;
      case 'TEXT':
        await this.getTemlates(1);
        break;
      default:
        await this.getTemlates(2);
        break;
    }

    this.RecepientsCount = await this.GetRecepientsCount();
    this.isLoading = false;
  }

  async SaveTemplate() {
    this.SavingTemplate = true;
    this.curTemplate.body = this.Message;
    this.curTemplate.subject = this.Subject;
    this.curTemplate.subtitle = this.Subtitle;
    this.curTemplate = await this.contactService.saveTemplate(this.curTemplate);
    this.TemplateSaved = true;
    this.SavingTemplate = false;
  }

  async DeleteTemplate() {
    var idx = this.templateArr.findIndex(a => a.name.trim().toUpperCase() == this.curTemplate.name.trim().toUpperCase());
    if (idx >= 0) {
      this.templateArr.splice(idx, 1);
      await this.contactService.deleteTemplate(this.curTemplate.id);
      this.Message = "";
      this.Subtitle = "";
      this.Subject = "";
      if (this.Transmission == 'EMAIL') await this.getTemlates(0);
      else await this.getTemlates(1);
    }

    this.TemplateDelete = false;
  }

  generateBody(
    firstName: string,
    lastName: string,
    namesList: string,
    absenteesList: string,
    message: string
  ): string {
    let result = '';
    if (
      this.ContactsList != null &&
      (this.Message.indexOf('[Attendees]') >= 0 ||
        this.Message.indexOf('[Absentees]') >= 0)
    )
      return '#Error: Unrecognized Merge Tags: Cannot Preview Message!';

    if (namesList == null) namesList = '';
    if (absenteesList == null) absenteesList = '';

    if (message.trim() == '') return '';
    if (message.indexOf('[AllNames]') >= 0 && namesList.trim() == '')
      return 'No Names Found!';
    if (
      // template contains absentees but this record doesn't have any absentees
      message.indexOf('[Absentees]') >= 0 &&
      absenteesList.trim() == ''
    )
      return '#Error: No value found for merge tag: [Absentees]!';
    let re = new RegExp(firstName + ',', 'g');
    let others = namesList.replace(re, '').trim();
    re = new RegExp(firstName, 'g');
    others = others.replace(re, '').trim();
    others = others.replace(/\s{2,10}/g, ' ').trim();
    if (others != '' && others[0] == ',') others = others.substring(1);
    if (others != '' && others[others.length - 1] == ',')
      others = others.substring(0, others.length - 1);
    others = others.trim();
    let attendeesList: string = this.GetAttendees(namesList, absenteesList);
    if (attendeesList == null) attendeesList = '';
    if (
      // template contains absentees but this record doesn't have any absentees
      message.indexOf('[Attendees]') >= 0 &&
      attendeesList.trim() == ''
    )
      return '#Error: No value found for merge tag: [Attendees]!';
    result = message;
    result = result.replace(
      /\[AllNames\]/g,
      this.AndJoin(namesList, firstName)
    );
    result = result.replace(
      /\[Absentees\]/g,
      this.AndJoin(absenteesList, firstName)
    );
    result = result.replace(
      /\[Attendees\]/g,
      this.AndJoin(attendeesList, firstName)
    );
    result = result.replace(
      /\[FullName\]/g,
      this.AndJoin(firstName + ' ' + lastName, '')
    );
    result = result.replace(/\[FirstName\]/g, this.AndJoin(firstName, ''));

    // if (this.Transmission == 'TEXT') result = result.substring(0, 160);

    return result;
  }

  AndJoin(names: string, primary: string) {
    let nameList: string[] = names.replace(/\s{2,10}/g, '').split(',');
    let countNames = nameList.length;
    let primaryIndex = nameList.indexOf(primary);
    if (primaryIndex >= 0) {
      nameList[primaryIndex] = nameList[nameList.length - 1];
      nameList[nameList.length - 1] = 'you';
    }
    let result = '';
    if (countNames > 1) {
      nameList.forEach((a) => {
        countNames = countNames - 1;
        if (countNames > 1) result = result + a + ', ';
        if (countNames == 1) result = result + a + ' and ';
      });
      result = result + nameList[nameList.length - 1];
    } else result = nameList[0];
    return result.replace(/\s{2,10}/g, ' ').trim();
  }

  GetAttendees(namesList: string, absenteesList: string) {
    if (namesList == null || namesList.trim() == '') return '';
    if (absenteesList == null || absenteesList.trim() == '') return namesList;

    let AllNamesArr: string[] = namesList.split(',').map((a) => a.trim());
    let absenteesArr: string[] = absenteesList.split(',').map((a) => a.trim());
    let attendeesArr: string[] = AllNamesArr.filter(
      (a) => absenteesArr.indexOf(a) < 0
    );
    let attendeesList = attendeesArr.join(', ').trim();
    if (attendeesList[attendeesList.length - 1] == ',')
      attendeesList = attendeesList.substring(0, attendeesList.length - 1);
    return attendeesList;
  }

  OnNew() {
    this.NewTemplate = true;
    this.TemplateSaved = false;
    this.newTemplateName = '';
  }

  async CreateNewTemplate() {
    let indexFound = this.templateArr
      .map((a) => a.name.toUpperCase().trim())
      .indexOf(this.newTemplateName.toUpperCase().trim());
    if (indexFound >= 0) {
      this.selectedTemplateIndex = indexFound;
      this.curTemplate = this.templateArr[indexFound];
      this.templateArr[indexFound].body = this.Message;
      this.templateArr[indexFound].subtitle = this.Subtitle;
      this.templateArr[indexFound].subject = this.Subject;
      this.NewTemplate = false;
      return;
    }
    var newtemp: MessageTemplate = new MessageTemplate();
    newtemp.id = 0;
    newtemp.name = this.newTemplateName;
    newtemp.body = this.Message
    newtemp.subject = this.Subject;
    newtemp.subtitle = this.Subtitle;
    newtemp.type = 0;
    if (this.Transmission == 'EMAIL')
      newtemp.type = 1;
    if (this.Transmission == 'NOTIFICATION')
      newtemp.type = 2;
    newtemp.creationDate = new Date();
    newtemp.createdBy = this.SenderEmail;
    newtemp = await this.contactService.saveTemplate(newtemp);
    this.templateArr.push(newtemp);
    this.NewTemplate = false;
    this.newTemplateName = '';
    this.selectedTemplateIndex = this.templateArr.indexOf(newtemp);
    this.curTemplate = this.templateArr[this.selectedTemplateIndex];
    indexFound = this.templateArr
      .map((a) => a.name.toUpperCase().trim())
      .indexOf(this.newTemplateName.toUpperCase().trim());
    if (indexFound >= 0) {
      this.selectedTemplateIndex = indexFound;
      this.curTemplate = this.templateArr[indexFound];
      this.Message = this.templateArr[indexFound].body;
      this.Message = this.Message;
      this.Subject = this.templateArr[indexFound].subject;
      this.Subtitle = this.templateArr[indexFound].subtitle;
      this.NewTemplate = false;
      return;
    }
  }

  CancelTemplateCreation() {
    this.NewTemplate = false;
    this.newTemplateName = '';
  }

  isDoubleByte(str) {
    str = str.replace("ْ", "'");
    str = str.replace("’", "'");
    this.Message = str;
    for (var i = 0, n = str.length; i < n; i++) {
      if (str.charCodeAt(i) > 255) {
        return true;
      }
    }
    return false;
  }

GetTransmissionCount(Message, Counter) {
  const hasAttachment =
    this.attachmentComponent?.getAttachments()?.length > 0;

  const attachmentCounter = hasAttachment ? 1 : 0;
  const hasMessage = Message != null && Message.length > 0;

  // Attachment only = 1
  if (!hasMessage && hasAttachment) {
    return 1;
  }

  // Nothing = 0
  if (!hasMessage) {
    return 0;
  }

  if (Counter == 160) {
    if (Message.length <= 160)
      return 1 + attachmentCounter;

    return Math.ceil(Message.length / 153) + attachmentCounter;
  } else {
    if (Message.length <= 70)
      return 1 + attachmentCounter;

    return Math.ceil(Message.length / 67) + attachmentCounter;
  }
}

  design() {
    this.PreviewMode = false;
    this.ConfirmSend = false;
    this.caretPos = null;
    this.Sent = false;
    this.TemplateSaved = false;
  }

  fixRTL(message: string): string {
    if (!message) return message;

    let processed = message;

    // 🔥 Only target elements that explicitly have dir="rtl"
    processed = processed.replace(/<p([^>]*)dir="rtl"([^>]*)>/g, (match, before, after) => {
      const attrs = before + after;

      if (attrs.includes('style=')) {
        return `<p${attrs.replace('style="', 'style="direction: rtl; text-align: right; ')}>`;
      }

      return `<p${attrs} style="direction: rtl; text-align: right;">`;
    });

    // Lists
    processed = processed.replace(/<li([^>]*)dir="rtl"([^>]*)>/g, (match, before, after) => {
      const attrs = before + after;

      if (attrs.includes('style=')) {
        return `<li${attrs.replace('style="', 'style="direction: rtl; text-align: right; ')}>`;
      }

      return `<li${attrs} style="direction: rtl; text-align: right;">`;
    });

    // Tables
    processed = processed.replace(/<td([^>]*)dir="rtl"([^>]*)>/g, (match, before, after) => {
      const attrs = before + after;

      if (attrs.includes('style=')) {
        return `<td${attrs.replace('style="', 'style="direction: rtl; ')}>`;
      }

      return `<td${attrs} style="direction: rtl;">`;
    });

    // 🔥 Wrap safely (LTR default)
    return `
    <div dir="ltr" style="direction:ltr; text-align:left; font-family: Arial; line-height:1.6;">
      ${processed}
    </div>
  `;
  }

  async send() {
    if (!this.EventId) this.EventId = 0;
    this.isSending = true;
    if (this.Transmission == 'EMAIL') {
      if (this.ContactsList != null && this.ContactsList.length != 0) {
        let sourceEmail: BatchEmail = new BatchEmail();
        sourceEmail.body = this.fixRTL(this.Message);
        sourceEmail.members = this.ContactsList;
        sourceEmail.subject = this.Subject;
        sourceEmail.senderName =
          this.identityService.firstName + ' ' + this.identityService.lastName;
        sourceEmail.senderEmail = this.identityService.email;
        sourceEmail.attachments = this.attachmentComponent.getAttachments();
        if (this.scheduleSend == false)
          sourceEmail.scheduleTime = new Date();
        else
          sourceEmail.scheduleTime = new Date(this.currentDate + ' ' + this.startTime);
        this.contactService.SendBatchEmails(sourceEmail, this.EventId);
        this.Acknowledge = this.globalService.Get('EMAILS_SENT');
        this.Sent = true;
        this.isSending = false;
      }
      if (this.FullContactsList != null && this.FullContactsList.length != 0) {
        let directSourceEmail: DirectBatchEmail = new DirectBatchEmail();
        directSourceEmail.body = this.fixRTL(this.Message);
        directSourceEmail.contacts = this.FullContactsList;
        directSourceEmail.subject = this.Subject;
        if (this.scheduleSend == false)
          directSourceEmail.scheduleTime = new Date();
        else
          directSourceEmail.scheduleTime = new Date(this.currentDate + ' ' + this.startTime);
        directSourceEmail.senderName =
          this.identityService.firstName + ' ' + this.identityService.lastName;
        directSourceEmail.senderEmail = this.identityService.email;
        directSourceEmail.attachments =
          this.attachmentComponent.getAttachments();
        this.contactService.SendDirectBatchEmails(
          directSourceEmail,
          this.EventId
        );
        this.Acknowledge = this.globalService.Get('EMAILS_SENT');
        this.Sent = true;
        this.isSending = false;
      }
    } else if (this.Transmission == 'TEXT') {
      if (this.ContactsList != null && this.ContactsList.length != 0) {
        if (await this.isSubscriptionExceeded(this.ContactsList.length) == true) {
          this.subscriptionError = true;
          return;
        }
        let sourceSMS: BatchText = new BatchText();
        sourceSMS.body = this.Message;
        sourceSMS.members = this.ContactsList;
        sourceSMS.attachments = this.attachmentComponent.getAttachments();
        if (this.scheduleSend == false)
          sourceSMS.scheduleTime = new Date();
        else
          sourceSMS.scheduleTime = new Date(this.currentDate + ' ' + this.startTime);
        sourceSMS.senderName =
          this.identityService.firstName + ' ' + this.identityService.lastName;
        this.contactService.SendBatchSMS(sourceSMS, this.EventId);
        this.Acknowledge = this.globalService.Get('TEXTS_SENT');
        this.Sent = true;
        this.isSending = false;
      }
      if (this.FullContactsList != null && this.FullContactsList.length != 0) {
        if (await this.isSubscriptionExceeded(this.FullContactsList.length) == true) {
          this.subscriptionError = true;
          return;
        }
        let directSourceSMS: DirectBatchText = new DirectBatchText();
        directSourceSMS.body = this.Message;
        directSourceSMS.contacts = this.FullContactsList;
        directSourceSMS.attachments =
          this.attachmentComponent.getAttachments();
        if (this.scheduleSend == false)
          directSourceSMS.scheduleTime = new Date();
        else
          directSourceSMS.scheduleTime = new Date(this.currentDate + ' ' + this.startTime);
        directSourceSMS.senderName =
          this.identityService.firstName + ' ' + this.identityService.lastName;
        this.contactService.SendDirectBatchSMS(directSourceSMS, this.EventId);
        this.Acknowledge = this.globalService.Get('TEXTS_SENT');
        this.Sent = true;
        this.isSending = false;
      }
    } else if (this.Transmission == 'NOTIFICATION') {
      if (this.ContactsList != null && this.ContactsList.length != 0) {
        let sourceNotification: BatchNotification = new BatchNotification();
        sourceNotification.body = this.fixRTL(this.Message);;
        sourceNotification.members = this.ContactsList;
        sourceNotification.title = this.Subject;
        sourceNotification.subtitle = this.Subtitle;
        sourceNotification.senderName =
          this.identityService.firstName + ' ' + this.identityService.lastName;
        if (this.scheduleSend == false)
          sourceNotification.scheduleTime = new Date();
        else
          sourceNotification.scheduleTime = new Date(this.currentDate + ' ' + this.startTime);
        this.contactService.SendBatchNotifications(sourceNotification, this.EventId);
        this.Acknowledge = this.globalService.Get('NOTIFICATIONS_SENT');
        this.Sent = true;
        this.isSending = false;
      }
      if (this.FullContactsList != null && this.FullContactsList.length != 0) {
        let sourceNotification: DirectBatchNotification = new DirectBatchNotification();
        sourceNotification.body = this.fixRTL(this.Message);;
        sourceNotification.contacts = this.FullContactsList;
        sourceNotification.title = this.Subject;
        sourceNotification.subtitle = this.Subtitle;
        sourceNotification.senderName =
          this.identityService.firstName + ' ' + this.identityService.lastName;
        if (this.scheduleSend == false)
          sourceNotification.scheduleTime = new Date();
        else
          sourceNotification.scheduleTime = new Date(this.currentDate + ' ' + this.startTime);
        this.contactService.SendDirectBatchNotifications(sourceNotification, this.EventId);
        this.Acknowledge = this.globalService.Get('NOTIFICATIONS_SENT');
        this.Sent = true;
        this.isSending = false;
      }
    }
    this.caretPos = null;
    this.TemplateSaved = false;
  }

  async isSubscriptionExceeded(recipientCount: number) {
    let currentCount = this.getCurrentCount(this.Message);

    if (
      this.Transmission === 'TEXT' &&
      this.attachmentComponent?.getAttachments()?.length > 0
    ) {
      currentCount += 1;
    }

    const Subscription = await this.appService.getSubscription();

    return (
      Subscription.textActual +
      (recipientCount * currentCount) >
      Subscription.textPlan
    );
  }

  getCurrentCount(message: string) {
    var textSize = this.isDoubleByte(message) == true ? 70 : 160;
    return Math.ceil(message.length / textSize);
  }

  async sendSelf() {
    if (this.Transmission == 'EMAIL') {
      let sourceEmail: BatchEmail = new BatchEmail();
      sourceEmail.body = this.fixRTL(this.Message);
      this.attachmentComponent.getAttachments();
      sourceEmail.members = [];
      sourceEmail.members.push(this.identityService.memberId);
      sourceEmail.subject = this.Subject;
      sourceEmail.senderName =
        this.identityService.firstName + ' ' + this.identityService.lastName;
      sourceEmail.senderEmail = this.identityService.email;
      if (this.scheduleSend == false)
        sourceEmail.scheduleTime = new Date();
      else
        sourceEmail.scheduleTime = new Date(this.currentDate + ' ' + this.startTime);
      sourceEmail.attachments = this.attachmentComponent.getAttachments();
      this.contactService.SendBatchEmails(sourceEmail, this.EventId);
      this.Acknowledge = this.globalService.Get('EMAILS_SENT');
      this.Sent = true;
    } else if (this.Transmission == 'TEXT') {
      if (await this.isSubscriptionExceeded(1) == true) {
        this.subscriptionError = true;
        return;
      }
      let sourceSMS: BatchText = new BatchText();
      sourceSMS.body = this.Message;
      sourceSMS.attachments =
        this.attachmentComponent.getAttachments();
      sourceSMS.members = [];
      sourceSMS.members.push(this.identityService.memberId);
      if (this.scheduleSend == false)
        sourceSMS.scheduleTime = new Date();
      else
        sourceSMS.scheduleTime = new Date(this.currentDate + ' ' + this.startTime);
      sourceSMS.senderName =
        this.identityService.firstName + ' ' + this.identityService.lastName;
      this.contactService.SendBatchSMS(sourceSMS, this.EventId);
      this.Acknowledge = this.globalService.Get('TEXTS_SENT');
      this.Sent = true;
    } if (this.Transmission == 'NOTIFICATION') {
      let sourceNotification: BatchNotification = new BatchNotification();
      sourceNotification.body = this.fixRTL(this.Message);
      sourceNotification.members = [];
      sourceNotification.members.push(this.identityService.memberId);
      sourceNotification.title = this.Subject;
      sourceNotification.subtitle = this.Subtitle;
      sourceNotification.senderName =
        this.identityService.firstName + ' ' + this.identityService.lastName;
      if (this.scheduleSend == false)
        sourceNotification.scheduleTime = new Date();
      else
        sourceNotification.scheduleTime = new Date(this.currentDate + ' ' + this.startTime);
      this.contactService.SendBatchNotifications(sourceNotification, this.EventId);
      this.Acknowledge = this.globalService.Get('NOTIFICATIONS_SENT');
      this.Sent = true;
    }
    this.caretPos = null;
    this.TemplateSaved = false;
    this.RecepientsCount = await this.GetRecepientsCount();
  }

  async getTemlates(type: number) {
    var x = null;
    switch (type) {
      case 0:
        this.templateArr = await this.contactService.getTextTemplates();
        break;
      case 1:
        this.templateArr = await this.contactService.getEmailTemplates();
        break;
      default:
        this.templateArr = await this.contactService.getNotificationTemplates();
        break;
    }
    this.RecepientsCount = await this.GetRecepientsCount();
  }

  async onTemplateChanged(value: any) {
    this.TemplateSaved = false;

    if (value == 'None') {
      this.Message = "";
      this.Subject = "";
      this.Subtitle = "";
      this.curTemplate = null;
      this.selectedTemplateIndex = 0;
    }
    else {
      this.Message = this.templateArr.filter((a) => a.name.trim().toUpperCase() == value.trim().toUpperCase())[0].body;
      this.Subject = this.templateArr.filter((a) => a.name.trim().toUpperCase() == value.trim().toUpperCase())[0].subject;
      this.Subtitle = this.templateArr.filter((a) => a.name.trim().toUpperCase() == value.trim().toUpperCase())[0].subtitle;
      this.curTemplate = this.templateArr.filter((a) => a.name.trim().toUpperCase() == value.trim().toUpperCase())[0];
      this.attachmentComponent.clearAttachments();
      this.selectedTemplateIndex = this.templateArr.indexOf(this.curTemplate);
    }

    this.attachmentComponent.clearAttachments();
    this.RecepientsCount = await this.GetRecepientsCount();
  }

  async insertName(tag) {
    if (this.caretPos == null) this.caretPos = this.Message.length;
    if (this.Message == '') this.Message = tag;
    else {
      if (this.caretEndPos > this.caretPos)
        this.Message =
          this.Message.substring(0, this.caretPos) +
          this.Message.substring(this.caretEndPos);
      this.Message =
        this.Message.substring(0, this.caretPos) +
        ' ' +
        tag +
        this.Message.substring(this.caretPos);
    }
    this.Message = this.Message.replace(/\s{2,10}/g, ' ').trim();
    this.PreviewMode = false;
    // this.MessageElement.nativeElement.focus();
    this.caretPos = null;
    this.caretEndPos = null;
    this.RecepientsCount = await this.GetRecepientsCount();
  }

  async getCaretPos(messageField) {
    if (messageField.selectionStart || messageField.selectionStart == '0') {
      this.caretPos = messageField.selectionStart;
      this.caretEndPos = messageField.selectionEnd;
    }
    this.RecepientsCount = await this.GetRecepientsCount();
  }

  GetRecepientsCount() {
    // if (this.EventId > 0)
    //   return await this.contactService.getEventCounter(
    //     this.EventId,
    //     this.GetStatus()
    //   );
    if (this.EventId == null) {
      if (this.ContactsList != null && this.ContactsList.length > 0)
        return this.ContactsList.length;
      if (this.RecepientsCount != null && this.RecepientsCount > 0)
        return this.RecepientsCount;
    }
  }

  GetStatus() {
    if (
      this.Message.indexOf('[Attendees]') >= 0 &&
      this.Message.indexOf('[Absentees]') >= 0
    )
      return 3;
    if (this.Message.indexOf('[Attendees]') >= 0) return 1;
    if (this.Message.indexOf('[Absentees]') >= 0) return 2;
    return 0;
  }

  async ScopeChanged(event: any) {
    this.RecepientsCount = 0;
    if (event.scope == null || (event.scope > 2 && event.detail == null)) {
      this.ContactsList = null;
      this.FullContactsList = null;
      return;
    }
    this.ContactsList = null;
    this.FullContactsList = await this.contactService.getContacts(event);
    if (event.scope < 3) this.GroupSender = this.church;
    else this.GroupSender = event.sender;
    this.RecepientsCount = this.FullContactsList.length;
  }

  isDemo() {
    return this.church == 'Church Services';
  }

  isCommunicationDisabled() {
    const rc = this.RecepientsCount == null ? 0 : this.RecepientsCount;
    const fl = this.FullContactsList == null ? 0 : this.FullContactsList.length;
    const cl = this.ContactsList == null ? 0 : this.ContactsList.length;

    const hasRecipients = rc + fl + cl > 0;
    const hasMessage = this.Message != null && this.Message.trim() != '';
    const hasAttachment =
      this.Transmission === 'TEXT' &&
      this.attachmentComponent?.getAttachments()?.length > 0;

    return (
      this.NewTemplate == true ||
      this.isDemo() ||
      this.Sent == true ||
      !hasRecipients ||
      (!hasMessage && !hasAttachment)
    );
  }
}
